// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"49":"saipa","99":"veniran","507":"ikco"}[chunkId] + "." + {"49":"fd7ed0c6","99":"b3a5eac2","507":"5c5b9023"}[chunkId] + ".css";
};